import React from 'react';
import Box from '../Box/Box';

import ToastIcon from './ToastIcon';
import ToastClose from './ToastClose';

import TToastBase from './@types/TToastBase';

const name = 'Toast';
const maxMsgChars = 164;

function validateMessage(message: string) {
  return Boolean(message && typeof message === 'string');
}

function limitMessageLength(message: string) {
  if (!validateMessage(message)) {
    throw new Error('Invalid message provided');
  }
  return message.slice(0, maxMsgChars);
}
const ToastBase = ({ signal, children, icon, onClose, ...rest }: TToastBase) => {
  const _children = limitMessageLength(children as string);
  return (
    <Box as="div" {...rest} name={name} modifiers={signal}>
      {icon && <ToastIcon icon={icon} />}
      <Box as="div" parent={name} name="body">
        {_children}
      </Box>
      {onClose && <ToastClose onClose={onClose} />}
    </Box>
  );
};

export default ToastBase;
